import styled from 'styled-components';

export const Button = styled.button`
  padding: 0.8em 3em;
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 15px;
  color: white;
  background-color: #006acb;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    padding: 1em;
    border-radius: 18px;
    font-size: 1em;
    width: 100%;
    svg {
      font-size: 21px;
    }
  }
`;
